import React from 'react'
import Typography from '@material-ui/core/Typography'
import './style.css';

export function ErrorHandlerTemplate() {
    return <div className='error-handler'>
        <Typography variant="h3" component="h1" align='center'>Упс! Что-то пошло не так :(</Typography>
        <Typography variant="h6" component="h2" align='center' gutterBottom>Code 403</Typography>
        <div className="gears">
            <div className="gear one">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            <div className="gear two">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            <div className="gear three">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
        </div>
    </div>;
}
